import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-comprobante-electronico',
  templateUrl: './comprobante-electronico.component.html',
  styleUrls: ['./comprobante-electronico.component.scss']
})
export class ComprobanteElectronicoComponent {

  constructor(private loginService: LoginService) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }

}
